<div class="d-flex align-items-center custom_column" *ngIf="!params.isItemCost">
    <div>
        <div *ngFor="let cost of customCost" class="mb-1">
            <div class="custom-cost">
                <div>
                    <span class="badges badges-qty" [ngClass]="(cost.toDate) ? 'badges-period' : 'badges-qty'">  
                         {{ cost.toDate ? 'Cost Period' : 'Cost Qty'}}</span>
                </div>
                <span class="gray-text" *ngIf="cost?.qty">{{ cost.fromDate | date:'MM/dd/yy' }} - {{ cost.qty }}</span>
                <span class="gray-text" *ngIf="cost?.toDate">{{ cost.fromDate | date:'MM/dd/yy' }} - {{ cost.toDate |date:'MM/dd/yy'}}</span>
                <span class="price">{{ cost.price | currency }}</span>
            </div>
        </div>
    </div>
    <div>
        <span class="custom-cost-btn" [ngClass]="{
            'add-cost-btn': params?.data?.CustomCost!= null
          }" (click)="addCustomCost()"><i class="fal fa-plus"></i> Add New</span>
    </div>
</div>
<div class="custom-cost" *ngIf="params?.data?.CustomCost?.hasMore && !params.isItemCost">
    <span class="custom-cost-btn see-more-btn ms-0" (click)="openSideBar()">See More</span>
</div>

<div class="item-cost" *ngIf="params?.isItemCost">
   {{(params?.data?.SkuCost || 0 ) | currency}}
   <div class="item-cost_icon" *ngIf="userInfo.isPlanYard" matTooltip = "This cost comes from your purchase orders can't be edited">
    <img class="img-fluid" src="../../../assets/images/application-icons/planyard-icon-v2.svg" alt="">
   </div>
</div>